<template>
  <div>
    <rhcn-card-v2 style="background-color: #fff;" :title="$t('message.refuse.klarnaRebutDrawer.otherUpload.title')" :showOptional="!disabled">
      <template #body>
        <div class="upload-info" v-for="item in ['0', '1', '2', '3', '4']" :key="item">
          <img class="upload-icon" src="@/views/transaction/refuse-manage/klarna-rebut/image/icon-base-info2x.png" alt="">
          <p >{{ getEnantiomericValue(fileTypeDict, item) }}</p>

          <el-tooltip v-if="item === '0'" effect="dark" :content="$t('message.refuse.klarnaRebutDrawer.otherUpload.tooltips')" placement="top" popper-class="text-popper">
            <span>
              <i class="el-icon-warning-outline"></i>
            </span>
          </el-tooltip>
        </div>

        <!-- 上传组件 -->
        <el-upload
          class="upload"
          drag
          v-if="!disabled"
          action="#"
          accept=".pdf"
          :file-list="formData"
          :auto-upload="false"
          :on-change="handleUploadChange"
          :show-file-list="false"
          multiple>
          <div class="upload-body">
            <img class="upload-body-icon" src="../../../image/icon-upload2x.png" alt="">
            <p class="upload-body-text">{{ $t('message.refuse.klarnaRebutDrawer.uploadTips') }}</p>
          </div>
        </el-upload>

        <!-- 文件列表 -->
        <div>
          <div class="file-item" v-for="(item, index) in formData" :key="index">
            <div class="file-item-info">
              <div style="display: flex; align-items: center; gap: 16px;">
                <img src="@/views/transaction/refuse-manage/klarna-rebut/image/icon-base-info2x.png" alt="">
                <a class="text-link" :href="item.fileUrl" target="_blank">{{ item.fileName.length > 10 ? item.fileName.substring(0, 10) + '...' : item.fileName }}</a>
              </div>
              <rhcn-select style="width: 200px;" :disabled="disabled" :placeholder="$t('message.refuse.klarnaRebutDrawer.otherUpload.fileTypePlaceholder')" v-model="item.fileType" :options="fileTypeSelectList"></rhcn-select>
            </div>
            <i v-if="!disabled" class="el-icon-delete" @click="handleDeleteFile(index)"></i>
          </div>
        </div>
      </template>
    </rhcn-card-v2>
  </div>
</template>

<script>
import RhcnSelect from '@/components/form/select.vue';
import { ShowWarningMessage } from '@/components/modal/tips/message-tips';
import RhcnCardV2 from '@/componentsV2/base-cmps/card/index.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import AppealService from '@/views/transaction/api/appeal-manage.service';

export default {
  components: {
    RhcnCardV2,
    RhcnSelect,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    goodType: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit('update:data', newValue);
      },
    },
  },
  data() {
    return {
      // 文件类型字典
      fileTypeDict: [],
      // 文件类型下拉框 此组件只需要五种 '0', '1', '2', '3', '4'
      fileTypeSelectList: [],
    };
  },
  mounted() {
    this.getFileType();
  },
  methods: {
    getEnantiomericValue,
    async getFileType() {
      const dict = await GlobalData.getDictList(['CHARGEBACK_APPEAL_FILE_TYPE']);
      this.fileTypeDict = initSelectedData(dict.CHARGEBACK_APPEAL_FILE_TYPE);
      this.fileTypeSelectList = initSelectedData(dict.CHARGEBACK_APPEAL_FILE_TYPE).filter(item => ['0', '1', '2', '3', '4'].includes(item.value));
    },

    // 上传文件
    async handleUploadChange(file) {
      if (file.raw.size > 2 * 1024 * 1024) {
        ShowWarningMessage(`${this.$t('message.validator.fileCannot')} 2M`);
        return;
      }

      const loading = this.$loading();
      const fileParam = {
        fileName: file.raw.name,
      };
      try {
        const res = await AppealService.uploadAppealFile(file.raw);
        fileParam.fileUrl = res;
        this.formData.push(fileParam);
        loading.close();
      } catch (err) {
        loading.close();
        throw err;
      }
    },

    // 根据下标删除文件
    handleDeleteFile(index) {
      this.formData.splice(index, 1);
    },

    downloadFile() {
      console.log(123);
    },
  },

};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
:deep(.el-upload-dragger) {
  width: 478px;
  height: 130px;
  border-color: none;
  &:active {
    border-color: $color-primary-purple;
  }
  &:hover {
    border-color: $color-primary-purple;
  }
}
.upload {
  width: 100%;
}

.upload-info {
  margin-bottom: 16px;

  display: flex;
  align-items: center;
  gap: 16px;

  .upload-icon {
    width: 16px;
    height: 16px;
  }
  p {
    font-family: PingFang HK, PingFang HK;
    font-weight: 400;
    font-size: 16px;
    color: #1A202C;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.upload-body {
  height: 100%;
  .upload-body-icon {
    margin-top: 13px;
    width: 60px;
    height: 60px;
  }

  .upload-body-text {
    font-family: Open Sans, Open Sans;
    font-weight: 400;
    font-size: 14px;
    color: #8D98AF;
    line-height: 18px;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
}

.file-item {
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 13px;
  .file-item-info {
    width: 458px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 7px 12px;
    background: #F7F8FA;
    border-radius: 2px;
    img {
      width: 16px;
      height: 16px;
      margin-right: 12px;
    }
    p {
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 14px;
      color: #1D2129;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}

.el-icon-delete {
  cursor: pointer;
}

.text-link {
  color: $color-primary-purple;
}

.download-all {
    display: flex;
    align-items: center;
    font-family: Urbanist, Urbanist;
    font-weight: 400;
    font-size: 16px;
    color: #503DF6;
    line-height: 22px;
    font-style: normal;
    text-transform: none;
    height: 38px;
    padding: 0 16px;
    img {
      margin-right: 4px;
      width: 14px;
      height: 14px;
    }

    &:hover {
      background: #F6F6FF;
      border-radius: 8px 8px 8px 8px;
    }
  }
</style>
